import React, {Component} from 'react'
import HorizontalInfoBlock from '../HorizontalInfoBlock'
import { matchAndReturnGatsbyImage } from '../utils'
import './horizontal-info-block-list.css'

class HorizontalInfoBlockList extends Component {

  renderLine() {
    return (
      <hr></hr>
    )
  }
  renderSpace() {
    return (
      <div>
      <br></br>
      <br></br>
      </div>
    )
  }
  render() {
    let data = this.props.data;
    let images = this.props.images;
    let dividing_line = this.props.divideBlocks ? this.renderLine() : null;
    let space = this.props.divideBlocks ? this.renderSpace() : null;
    let blocks = data.map(
      (datum, index) =>
        <div>
          {dividing_line}
          {space}
          <HorizontalInfoBlock
            isImgShort={this.props.isImgShort}
            data={datum}
            key={index}
            bigTitle = {this.props.bigTitle}
            isImageOnRight = {this.props.isAlternating && index % 2 !== 0}
            fluid={matchAndReturnGatsbyImage(images, datum.src)}>
          </HorizontalInfoBlock>

          {space}
        </div>);

    return (
      <div>
        {blocks}
        {dividing_line}
      </div>
    );
  }
}

export default HorizontalInfoBlockList
